import React from "react";

const VIDEO_ID = "LnRxzC4aiJQ";

export const VideoSection = () => {
  return (
    <section
      id="video"
      className="relative w-full py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#050505]"
      data-testid="video-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="font-display text-xs tracking-[0.4em] uppercase text-[#FF007F] mb-6">
            // 05 — Watch
          </p>
          <h2 className="font-display font-bold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
            Bemutató videó
          </h2>
          <p className="font-body text-white/50 mt-6 max-w-xl mx-auto">
            Nézd meg a CHARGE Charlie Cover Band élő bemutatkozását.
          </p>
        </div>

        <div
          className="relative mx-auto max-w-5xl"
          data-testid="video-embed"
        >
          {/* Glow layers */}
          <div className="absolute -inset-1 bg-gradient-to-r from-[#00E5FF] via-[#7000FF] to-[#FF007F] opacity-30 blur-xl" />
          <div className="absolute -inset-px bg-gradient-to-r from-[#00E5FF]/60 to-[#FF007F]/60" />

          {/* Video frame */}
          <div className="relative aspect-video bg-black overflow-hidden">
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO_ID}`}
              title="CHARGE Charlie Cover Band - Bemutató videó"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 h-full w-full"
              data-testid="video-iframe"
            />
          </div>
        </div>

        {/* Decorative tag below */}
        <div className="mt-8 flex items-center justify-center gap-3 text-white/40 text-xs uppercase tracking-[0.3em] font-display">
          <span className="block h-px w-12 bg-white/20" />
          A zene gyógyít
          <span className="block h-px w-12 bg-white/20" />
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
